module.exports = {
    PortraitPrimary: "portrait-primary",
    PortraitSecondary: "portrait-secondary",
    LandscapePrimary: "landscape-primary",
    LandscapeSecondary: "landscape-secondary"
}